/*!
 * Stanbarry Augen-Gravur · assets/augen-gravur.js
 * Foto hochladen → Augen automatisch finden (MediaPipe, läuft im Browser) → Punktraster-Vorschau
 * auf dem Produktfoto → Gravurdateien als Datei-Properties an den Warenkorb-Artikel.
 * Konfiguration und Texte kommen aus <script type="application/json" class="ag-config"> im Block.
 */
(function () {
  'use strict';
  if (window.AugenGravur) return;

  // Gravurfeld im Produktfoto augen-gravur-armband.jpg (2000×2000), einmal ausgemessen.
  // Das Feld ist leicht gebogen: Ober- und Unterkante hängen in der Mitte um „sag“ px durch.
  const PHOTO = {
    size: 2000,
    band: { x0: 659, x1: 1334, topL: 1365, topR: 1367, botL: 1548, botR: 1553, sagTop: 16, sagBot: 15 },
    // Helligkeit des polierten Metalls quer über die Platte (0 = links, 1 = rechts)
    metal: [[0, 232], [0.3, 242], [0.6, 247], [0.8, 232], [0.9, 205], [1, 170]],
    close: { x: 600, y: 1305, w: 795, h: 320 },
  };
  // Wo die Augen im Rahmen sitzen (Anteil von Breite/Höhe); MediaPipe-Augenpunkte liegen etwas unter der Pupille
  const EYE_L = 0.30, EYE_R = 0.70, EYE_Y = 0.60, KP_BELOW = 0.06;
  const MP = 'https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@0.10.14';
  const MODEL = 'https://storage.googleapis.com/mediapipe-models/face_detector/blaze_face_short_range/float16/1/blaze_face_short_range.tflite';

  const clamp = (v, a, b) => v < a ? a : v > b ? b : v;
  const mk = (w, h) => { const c = document.createElement('canvas'); c.width = w; c.height = h; return c; };
  const ctx2d = c => c.getContext('2d', { willReadFrequently: true });
  const dpr = () => Math.min(3, window.devicePixelRatio || 1);
  const toBlob = (c, type, q) => new Promise(r => c.toBlob(r, type, q));

  /* ---------- Gravierbare Symbole (Ersatz für Emojis): eine Vektorform für Knopf und Gravur-Vorschau ---------- */
  // 24×24-Box; sw = Strichstärke (Umriss), sonst gefüllt
  const HEART = 'M12 20.5C11 19.6 3 14.4 3 8.9 3 6 5.2 4 7.7 4c1.8 0 3.3 1 4.3 2.5C13 5 14.5 4 16.3 4 18.8 4 21 6 21 8.9c0 5.5-8 10.7-9 11.6Z';
  const STAR = 'M12 2.8L14.53 9.32L21.51 9.71L16.09 14.13L17.88 20.89L12 17.1L6.12 20.89L7.91 14.13L2.49 9.71L9.47 9.32Z';
  const SYMBOLS = [
    { ch: '♥', name: 'Herz', d: HEART },
    { ch: '♡', name: 'Herz (Umriss)', d: HEART, sw: 2 },
    { ch: '∞', name: 'Unendlich', d: 'M12 12c-1.8-2.4-3.4-4-5.5-4a4 4 0 0 0 0 8c2.1 0 3.7-1.6 5.5-4Zm0 0c1.8 2.4 3.4 4 5.5 4a4 4 0 0 0 0-8c-2.1 0-3.7 1.6-5.5 4Z', sw: 2.1 },
    { ch: '★', name: 'Stern', d: STAR },
    { ch: '☆', name: 'Stern (Umriss)', d: STAR, sw: 1.8 },
    { ch: '☾', name: 'Mond', d: 'M12 3A9 9 0 1 0 20.44 15.13A7.4 7.4 0 0 1 12 3Z' },
    { ch: '✿', name: 'Blume', d: 'M15.9 7.4a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0ZM20.66 10.85a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0ZM18.84 16.45a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0ZM12.96 16.45a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0ZM11.14 10.85a3.9 3.9 0 1 0 -7.8 0a3.9 3.9 0 1 0 7.8 0Z' },
    { ch: '♪', name: 'Note', d: 'M11.5 17.3a2.8 2.8 0 1 1-5.6 0a2.8 2.8 0 1 1 5.6 0ZM10.2 17.3V3.5h1.8v13.8ZM12 3.5c.6 2.6 2.4 3.6 4.2 4.6 1.6.9 2.1 2.8 1.2 4.6.3-1.6-.6-2.7-2-3.3-1.3-.6-2.6-1.2-3.4-2.2Z' },
    { ch: '†', name: 'Kreuz', d: 'M10.9 2.5h2.2v5.2h4.6v2.2h-4.6v11.6h-2.2V9.9H6.3V7.7h4.6Z' },
    { ch: '✦', name: 'Funkeln', d: 'M12 3.3c.9 5.3 3.4 7.8 8.7 8.7-5.3.9-7.8 3.4-8.7 8.7-.9-5.3-3.4-7.8-8.7-8.7 5.3-.9 7.8-3.4 8.7-8.7Z' },
  ];
  SYMBOLS.forEach(s => { let p = null; s.path = () => p || (p = new Path2D(s.d)); });
  const SYM = new Map(SYMBOLS.map(s => [s.ch, s]));
  const symSvg = s => `<svg viewBox="0 0 24 24" aria-hidden="true"><path d="${s.d}" ${s.sw
    ? `fill="none" stroke="currentColor" stroke-width="${s.sw}" stroke-linejoin="round" stroke-linecap="round"`
    : 'fill="currentColor"'}/></svg>`;

  /* ---------- Geometrie des Gravurfelds (ungespiegelt), einmal vorberechnet ---------- */
  const B = PHOTO.band;
  const RX0 = B.x0 - 6, RX1 = B.x1 + 6;
  const RY0 = Math.floor(Math.min(B.topL, B.topR)) - 6;
  const RY1 = Math.ceil(Math.max(B.botL, B.botR) + B.sagBot) + 6;
  const RW = RX1 - RX0, RH = RY1 - RY0;
  // Rückseite: Von hinten ist die Platte andersherum gewölbt. Das gespiegelte Foto wird dafür über die
  // ganze Plattenbreite (inkl. Laschen) spaltenweise nach oben gezogen, in der Mitte am stärksten.
  // Faktor so gewählt, dass das Gravurfeld genau die gespiegelte Wölbung bekommt (−sag statt +sag).
  const PL0 = PHOTO.close.x, PL1 = PHOTO.close.x + PHOTO.close.w;
  const BACK_K = (B.sagTop + B.sagBot) / Math.pow((B.x1 - B.x0) / (PL1 - PL0), 2);
  const backShift = x => { const u = (2 * x - PL0 - PL1) / (PL1 - PL0); return u <= -1 || u >= 1 ? 0 : BACK_K * (1 - u * u); };
  const RY0B = RY0 - Math.ceil(BACK_K) - 1;                              // Rückseite reicht weiter nach oben
  const colTop = new Float32Array(RW), colBot = new Float32Array(RW), colV = new Float32Array(RW), colM = new Float32Array(RW);
  const colD = new Float32Array(RW);
  function metalAt(v) { // Catmull-Rom durch die Stützstellen
    const P = PHOTO.metal; v = clamp(v, 0, 1);
    let i = 0; while (i < P.length - 2 && v > P[i + 1][0]) i++;
    const p0 = P[Math.max(0, i - 1)][1], p1 = P[i][1], p2 = P[i + 1][1], p3 = P[Math.min(P.length - 1, i + 2)][1];
    const t = (v - P[i][0]) / (P[i + 1][0] - P[i][0]);
    return 0.5 * (2 * p1 + (-p0 + p2) * t + (2 * p0 - 5 * p1 + 4 * p2 - p3) * t * t + (-p0 + 3 * p1 - 3 * p2 + p3) * t * t * t);
  }
  for (let i = 0; i < RW; i++) {
    const x = RX0 + i + 0.5, v = (x - B.x0) / (B.x1 - B.x0), u = 2 * v - 1, s = 1 - u * u;
    colTop[i] = B.topL + (B.topR - B.topL) * v + B.sagTop * s;
    colBot[i] = B.botL + (B.botR - B.botL) * v + B.sagBot * s;
    colV[i] = v; colM[i] = metalAt(v); colD[i] = backShift(x);
  }

  /* ---------- Bildverarbeitung (reine Funktionen) ---------- */
  function sample(m, W, H, x, y) {
    x = clamp(x, 0, W - 1); y = clamp(y, 0, H - 1);
    const x0 = x | 0, y0 = y | 0, x1 = Math.min(x0 + 1, W - 1), y1 = Math.min(y0 + 1, H - 1), fx = x - x0, fy = y - y0;
    return (m[y0 * W + x0] * (1 - fx) + m[y0 * W + x1] * fx) * (1 - fy) + (m[y1 * W + x0] * (1 - fx) + m[y1 * W + x1] * fx) * fy;
  }
  function boxBlur(src, W, H, r) {
    const tmp = new Float32Array(W * H), out = new Float32Array(W * H);
    let a = src;
    for (let pass = 0; pass < 2; pass++) {
      for (let y = 0; y < H; y++) {
        const row = y * W; let s = 0;
        for (let x = -r; x <= r; x++) s += a[row + clamp(x, 0, W - 1)];
        for (let x = 0; x < W; x++) {
          tmp[row + x] = s / (2 * r + 1);
          s += a[row + Math.min(x + r + 1, W - 1)] - a[row + Math.max(x - r, 0)];
        }
      }
      for (let x = 0; x < W; x++) {
        let s = 0;
        for (let y = -r; y <= r; y++) s += tmp[clamp(y, 0, H - 1) * W + x];
        for (let y = 0; y < H; y++) {
          out[y * W + x] = s / (2 * r + 1);
          s += tmp[Math.min(y + r + 1, H - 1) * W + x] - tmp[Math.max(y - r, 0) * W + x];
        }
      }
      a = out.slice();
    }
    return a;
  }
  function histPct(L) {
    const hist = new Uint32Array(256);
    for (let i = 0; i < L.length; i++) hist[Math.min(255, (L[i] * 255) | 0)]++;
    return p => { let n = 0; const lim = p * L.length; for (let i = 0; i < 256; i++) { n += hist[i]; if (n >= lim) return (i + 0.5) / 255; } return 1; };
  }
  // Graustufen für den Laser: 0 = voll lasern, 1 = blankes Metall. up = Ausgabepixel pro Fotopixel
  function toneMap(L, W, H, up) {
    const r = Math.max(1, Math.round(W / 700), Math.round(up * 0.8));
    const soft = boxBlur(L, W, H, Math.max(2 * r, Math.round(up * 1.5)));  // kantenerhaltend entrauschen
    for (let i = 0; i < L.length; i++) {
      const d = (L[i] - soft[i]) / 0.07, w = 0.85 * Math.exp(-d * d);
      L[i] = L[i] * (1 - w) + soft[i] * w;
    }
    let pct = histPct(L);
    const lo = pct(0.005), hi = pct(0.995), span = Math.max(0.08, hi - lo);
    for (let i = 0; i < L.length; i++) L[i] = clamp((L[i] - lo) / span, 0, 1);
    pct = histPct(L);                                                      // Haut (Median) hell ziehen
    const med = clamp(pct(0.5), 0.05, 0.95), gam = clamp(Math.log(0.64) / Math.log(med), 0.45, 1.4);
    for (let i = 0; i < L.length; i++) L[i] = Math.pow(L[i], gam);
    const big = boxBlur(L, W, H, Math.max(2, Math.round(H * 0.18)));      // lokaler Kontrast: Iris, Lidfalte, Brauen
    for (let i = 0; i < L.length; i++) L[i] = clamp(L[i] + 0.5 * (L[i] - big[i]), 0, 1);
    const small = boxBlur(L, W, H, r);                                     // etwas Schärfe
    for (let i = 0; i < L.length; i++) L[i] = clamp(L[i] + 0.45 * (L[i] - small[i]), 0, 1);
    for (let i = 0; i < L.length; i++) L[i] = clamp((1 - Math.pow(1 - L[i], 1.35)) * 1.05, 0, 1);
    return L;
  }
  function dither(L, W, H) { // Floyd-Steinberg, serpentinenförmig → 1 = Laserpunkt
    const e = Float32Array.from(L), m = new Float32Array(W * H);
    const add = (x, y, v) => { if (x >= 0 && x < W && y < H) e[y * W + x] += v; };
    for (let y = 0; y < H; y++) {
      const dir = y & 1 ? -1 : 1;
      for (let k = 0; k < W; k++) {
        const x = dir > 0 ? k : W - 1 - k, i = y * W + x, o = e[i], n = o < 0.5 ? 0 : 1, er = o - n;
        m[i] = 1 - n;
        add(x + dir, y, er * 7 / 16); add(x - dir, y + 1, er * 3 / 16); add(x, y + 1, er * 5 / 16); add(x + dir, y + 1, er / 16);
      }
    }
    return m;
  }
  function toCanvas(values, W, H, invert) {
    const c = mk(W, H), g = c.getContext('2d'), im = g.createImageData(W, H);
    for (let i = 0; i < values.length; i++) {
      const v = Math.round(255 * (invert ? 1 - values[i] : values[i]));
      im.data[4 * i] = im.data[4 * i + 1] = im.data[4 * i + 2] = v; im.data[4 * i + 3] = 255;
    }
    g.putImageData(im, 0, 0); return c;
  }
  function buildPyramid(c) { // Halbierungsstufen: große Handyfotos schnell und sauber verkleinern
    const p = [c];
    while (Math.max(p[p.length - 1].width, p[p.length - 1].height) > 700) {
      const s = p[p.length - 1], h = mk(Math.round(s.width / 2), Math.round(s.height / 2)), g = h.getContext('2d');
      g.imageSmoothingQuality = 'high'; g.drawImage(s, 0, 0, h.width, h.height); p.push(h);
    }
    return p;
  }

  /* ---------- Augen-Erkennung (einmal pro Seite geladen) ---------- */
  let detP = null;
  function loadDetector() {
    if (!detP) {
      detP = (async () => {
        const v = await import(MP + '/vision_bundle.mjs');
        const fs = await v.FilesetResolver.forVisionTasks(MP + '/wasm');
        return v.FaceDetector.createFromOptions(fs, {
          baseOptions: { modelAssetPath: MODEL, delegate: 'CPU' }, runningMode: 'IMAGE', minDetectionConfidence: 0.45,
        });
      })();
      detP.catch(() => { detP = null; });
    }
    return detP;
  }
  const timeout = (p, ms) => Promise.race([p, new Promise((_, r) => setTimeout(() => r(new Error('timeout')), ms))]);
  function facesIn(det, img, R) {
    const s = Math.min(1, 1024 / Math.max(R.w, R.h)), c = mk(Math.round(R.w * s), Math.round(R.h * s));
    c.getContext('2d').drawImage(img, R.x, R.y, R.w, R.h, 0, 0, c.width, c.height);
    return det.detect(c).detections.filter(d => d.keypoints && d.keypoints.length >= 2).map(d => {
      const p = d.keypoints.slice(0, 2).map(k => ({ x: R.x + k.x * R.w, y: R.y + k.y * R.h })).sort((a, b) => a.x - b.x);
      return { l: p[0], r: p[1], d: Math.hypot(p[1].x - p[0].x, p[1].y - p[0].y) };
    });
  }
  function findEyes(det, img) {
    const W = img.width, H = img.height;
    let found = facesIn(det, img, { x: 0, y: 0, w: W, h: H });
    if (!found.length) { // kleine Gesichter: in Kacheln suchen
      const s = Math.min(W, H) * 0.55;
      for (let iy = 0; iy < 3 && !found.length; iy++) for (let ix = 0; ix < 3; ix++) {
        found = found.concat(facesIn(det, img, { x: (W - s) * ix / 2, y: (H - s) * iy / 2, w: s, h: s }));
      }
    }
    return found.sort((a, b) => b.d - a.d)[0] || null;
  }

  /* ---------- Warenkorb-Hooks (einmal pro Seite, verteilen an alle Instanzen) ---------- */
  const instances = [];
  // Gravur-Uploads, die nach dem „In den Warenkorb“ noch laufen: Wer in dieser Zeit zur Kasse oder auf eine andere
  // Seite will, wartet kurz (max. 20 s), sonst bricht der Browser den Upload ab und am Artikel stünde ein leerer Link.
  const pendingUploads = new Set();
  function trackUpload(p) { pendingUploads.add(p); const off = () => pendingUploads.delete(p); p.then(off, off); }
  document.addEventListener('click', e => {
    if (!pendingUploads.size || !e.target.closest) return;
    const t = e.target.closest('[name="checkout"], .shopify-payment-button__button, a[href]');
    if (!t || t.dataset.agGo) return;
    if (t.tagName === 'A') {
      const h = t.getAttribute('href') || '';
      if (!h || h.startsWith('#') || t.target === '_blank' || /^(javascript|mailto|tel):/i.test(h)) return;
    }
    e.preventDefault(); e.stopImmediatePropagation();
    t.setAttribute('aria-busy', 'true'); t.style.opacity = '.6';
    Promise.race([Promise.allSettled([...pendingUploads]), new Promise(r => setTimeout(r, 20000))]).then(() => {
      t.removeAttribute('aria-busy'); t.style.opacity = ''; t.dataset.agGo = '1';
      t.click(); setTimeout(() => { delete t.dataset.agGo; }, 2000);
    });
  }, true);
  const origFetch = window.fetch;
  function variantOf(body) {
    try {
      if (body instanceof FormData || body instanceof URLSearchParams) return String(body.get('id') || '');
      if (typeof body === 'string') {
        try { const j = JSON.parse(body); return String(j.id || (j.items && j.items[0] && j.items[0].id) || ''); }
        catch (_) { return String(new URLSearchParams(body).get('id') || ''); }
      }
    } catch (_) {}
    return '';
  }
  const ownerOf = body => { const id = variantOf(body); return id && instances.find(x => x.ids.has(id)); };
  const fake422 = msg => new Response(JSON.stringify({ status: 422, message: 'Cart Error', description: msg }),
    { status: 422, headers: { 'Content-Type': 'application/json' } });
  function stripContentType(h) {
    if (!h) return h;
    if (h instanceof Headers) { const n = new Headers(h); n.delete('Content-Type'); return n; }
    const n = {}; Object.keys(h).forEach(k => { if (k.toLowerCase() !== 'content-type') n[k] = h[k]; }); return n;
  }
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || '';
    const inst = /\/cart\/add/.test(url) && init && init.body ? ownerOf(init.body) : null;
    if (!inst) return origFetch.apply(window, arguments);
    const p = inst.problem();
    if (p) { inst.showProblem(p); return Promise.resolve(fake422(p.msg)); }
    return inst.withFiles(init.body).then(fd => {
      const next = Object.assign({}, init);
      if (fd) { if (fd !== init.body) next.headers = stripContentType(init.headers); next.body = fd; }
      const qty = fd ? Number(fd.get('quantity')) || 1 : 1;
      return inst.addUpsell(qty).catch(() => {}).then(() => origFetch.call(window, input, next));
    }, () => origFetch.call(window, input, init));
  };
  const oOpen = XMLHttpRequest.prototype.open, oSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.open = function (m, u) { this.__agUrl = String(u || ''); return oOpen.apply(this, arguments); };
  XMLHttpRequest.prototype.send = function (body) { // Fremd-Skripte per XHR: nur Pflichtfelder absichern
    if (/\/cart\/add/.test(this.__agUrl || '') && body) {
      const inst = ownerOf(body), p = inst && inst.problem();
      if (p) { inst.showProblem(p); return; }
    }
    return oSend.call(this, body);
  };
  document.addEventListener('click', e => { // Klick auf „In den Warenkorb“ ohne Foto abfangen
    const btn = e.target.closest && e.target.closest('button[name="add"], .product-form__submit, [data-add-to-cart]');
    const form = btn && btn.closest('form');
    if (!form || !/\/cart\/add/.test(form.getAttribute('action') || '')) return;
    const idIn = form.querySelector('[name="id"]');
    const inst = idIn && instances.find(x => x.ids.has(String(idIn.value)));
    const p = inst && inst.problem();
    if (p) { e.preventDefault(); e.stopImmediatePropagation(); inst.showProblem(p); }
  }, true);

  /* ---------- Eine Customizer-Instanz ---------- */
  function init(root) {
    if (root.dataset.agInit) return;
    let cfg;
    try { cfg = JSON.parse(root.querySelector('.ag-config').textContent); } catch (_) { return; }
    root.dataset.agInit = '1';
    const T = cfg.t, P = cfg.props, ENG = cfg.eng, ASPECT = ENG.wMM / ENG.hMM;
    const PREV_W = B.x1 - B.x0, PREV_H = Math.round(PREV_W / ASPECT);   // Vorschau ≈ 1 Fotopixel pro Punkt
    // Fehlt ein Element (z. B. altes HTML aus dem Shop-Cache direkt nach einem Update), arbeitet der Code mit einem
    // losen Platzhalter weiter, statt abzubrechen
    const q = s => root.querySelector(s) || document.createElement('i');
    const el = {
      file: q('.ag-file'), upload: q('.ag-upload'), work: q('.ag-work'), pv: q('.ag-pv'), pvCanvas: q('.ag-pv canvas'),
      busy: q('.ag-busy'), crop: q('.ag-cropbox canvas'), cropHint: q('.ag-crophint'),
      status: q('.ag-status'), reset: q('.ag-reset'), change: q('.ag-change'), warn: q('.ag-warn'), err: q('.ag-err'),
      backCheck: q('.ag-back-check'), backPanel: q('.ag-panel'), pvBack: q('.ag-pv-back canvas'), l1: q('.ag-l1'), l2: q('.ag-l2'),
      c1: q('.ag-c1'), c2: q('.ag-c2'), fonts: q('.ag-fonts'), backErr: q('.ag-back-err'),
      symHint: q('.ag-sym-hint'),
    };
    const st = {
      img: null, pyr: null, token: 0, fver: 0, bver: 0, crop: null, base: null, touched: false, busy: false, detecting: false,
      back: { on: false, l1: '', l2: '', font: 'script' },
    };
    const comp = { front: null, back: null }, orig = { front: null, back: null };
    const regionY = side => side === 'back' ? RY0B : RY0;

    /* Produktfoto laden (erst bei Bedarf) */
    let photoP = null;
    function loadPhoto() {
      if (!photoP) {
        photoP = new Promise((res, rej) => {
          const im = new Image(); im.crossOrigin = 'anonymous';
          im.onload = () => res(im); im.onerror = rej; im.src = cfg.photo;
        }).then(im => {
          const S = PHOTO.size;
          // Vorderseite: Foto wie es ist
          const f = mk(S, S), gf = ctx2d(f);
          gf.drawImage(im, 0, 0, S, S);
          comp.front = f; orig.front = gf.getImageData(RX0, RY0, RW, RH);
          // Rückseite: Plattenbereich spaltenweise nach oben ziehen (Wölbung umkehren), dann spiegeln
          const w = mk(S, S), gw = ctx2d(w);
          gw.drawImage(im, 0, 0, S, S);
          const y0 = PHOTO.close.y - 20, h = PHOTO.close.h + 80;
          for (let x = PL0; x < PL1; x++) {
            const d = backShift(x + 0.5);
            if (d > 0.05) gw.drawImage(im, x, y0 + d, 1, h, x, y0, 1, h);
          }
          const b = mk(S, S), gb = ctx2d(b);
          gb.translate(S, 0); gb.scale(-1, 1); gb.drawImage(w, 0, 0); gb.setTransform(1, 0, 0, 1, 0, 0);
          comp.back = b; orig.back = gb.getImageData(S - RX1, RY0B, RW, RY1 - RY0B);
          invalidate('front', 'back');
        });
        photoP.catch(() => { photoP = null; });
      }
      return photoP;
    }

    // Gravurfeld neu „polieren“ und die Maske (1 = Laser) aufs Metall setzen.
    // Rückseite = gespiegeltes, umgewölbtes Foto: gleiche Spalten, um colD nach oben versetzt.
    function paint(side, mask, mW, mH) {
      const c = comp[side]; if (!c) return;
      const back = side === 'back', src = orig[side].data, ry0 = regionY(side), rh = RY1 - ry0;
      if (!mask && side === 'front') { ctx2d(c).putImageData(orig.front, RX0, RY0); return; } // Beispielgravur zeigen
      const out = new ImageData(RW, rh), o = out.data;
      for (let yy = 0; yy < rh; yy++) {
        const y = ry0 + yy + 0.5;
        for (let xx = 0; xx < RW; xx++) {
          const col = back ? RW - 1 - xx : xx, x = RX0 + col + 0.5, i = (yy * RW + xx) * 4;
          const top = back ? colTop[col] - colD[col] : colTop[col], bot = back ? colBot[col] - colD[col] : colBot[col];
          const fa = clamp(Math.min(y - (top - 2.5), (bot + 2.5) - y, (x - (B.x0 - 6)) / 6, ((B.x1 + 6) - x) / 6), 0, 1);
          if (fa <= 0) { o[i] = src[i]; o[i + 1] = src[i + 1]; o[i + 2] = src[i + 2]; o[i + 3] = 255; continue; }
          const t = (y - top) / (bot - top), M = colM[col] + (clamp(t, 0, 1) - 0.5) * 16;
          let a = 0;
          if (mask) {
            const ea = clamp(Math.min(y - top, bot - y, x - B.x0, B.x1 - x) + 0.5, 0, 1);
            if (ea > 0) a = sample(mask, mW, mH, (back ? 1 - colV[col] : colV[col]) * mW - 0.5, t * mH - 0.5) * ea;
          }
          const E = 40 + 0.18 * M, val = M + (E - M) * a * 0.93;   // gelaserter Punkt: mattes Dunkelgrau
          o[i] = src[i] * (1 - fa) + val * fa;
          o[i + 1] = src[i + 1] * (1 - fa) + val * fa;
          o[i + 2] = src[i + 2] * (1 - fa) + (val + 2) * fa;
          o[i + 3] = 255;
        }
      }
      ctx2d(c).putImageData(out, back ? PHOTO.size - RX1 : RX0, ry0);
    }

    /* Kundenfoto → Gravur */
    function drawSource(g, k) {
      let i = 0; while (i + 1 < st.pyr.length && k * Math.pow(2, i + 1) <= 1) i++;
      g.drawImage(st.pyr[i], 0, 0, st.img.width, st.img.height);
    }
    function cropCanvas(W, H) {
      const c = mk(W, H), g = ctx2d(c), { cx, cy, fw, a } = st.crop, k = W / fw;
      g.fillStyle = '#fff'; g.fillRect(0, 0, W, H);
      g.imageSmoothingEnabled = true; g.imageSmoothingQuality = 'high';
      g.translate(W / 2, H / 2); g.scale(k, k); g.rotate(-a); g.translate(-cx, -cy);
      drawSource(g, k);
      return c;
    }
    function engraveFront(W, H) {
      const d = ctx2d(cropCanvas(W, H)).getImageData(0, 0, W, H).data, L = new Float32Array(W * H);
      for (let i = 0; i < L.length; i++) L[i] = (0.299 * d[4 * i] + 0.587 * d[4 * i + 1] + 0.114 * d[4 * i + 2]) / 255;
      const gray = toneMap(L, W, H, Math.max(1, W / st.crop.fw));
      return { gray, mask: dither(gray, W, H) };
    }

    /* Rückseiten-Text: zwei eigene Schriften (Theme-Assets, im Block per @font-face eingebunden) */
    function fontOf(key) {
      return key === 'clean'
        ? { fam: '"AG Montserrat", "Helvetica Neue", Arial, sans-serif', weight: 500, k1: 0.36, k2: 0.27 }
        : { fam: '"AG Great Vibes", "Snell Roundhand", cursive', weight: 400, k1: 0.62, k2: 0.44 };
    }
    const loadFont = key => {
      const f = fontOf(key);
      return document.fonts ? document.fonts.load(`${f.weight} 40px ${f.fam}`).then(() => invalidate('back')).catch(() => {}) : null;
    };
    const backLines = () => [st.back.l1, st.back.l2].map(s => s.trim()).filter(Boolean);
    // Symbole aus der Auswahl zeichnen wir selbst (gleiche Vektorform wie auf dem Knopf):
    // sieht auf jedem Gerät gleich aus und wird nie als buntes Emoji dargestellt
    const symW = s => s * 0.66;
    function drawSym(g, ch, x, cy, s) {
      const def = SYM.get(ch), w = symW(s), k = w / 24;
      g.save(); g.translate(x, cy - w / 2); g.scale(k, k); g.lineJoin = 'round'; g.lineCap = 'round';
      if (def.sw) { g.lineWidth = def.sw; g.stroke(def.path()); } else g.fill(def.path());
      g.restore();
    }
    function runsOf(line) {
      const out = []; let buf = '';
      for (const ch of line) { if (SYM.has(ch)) { if (buf) out.push({ t: buf }); buf = ''; out.push({ sym: ch }); } else buf += ch; }
      if (buf) out.push({ t: buf });
      return out;
    }
    function textMask(W, H) {
      const lines = backLines(); if (!st.back.on || !lines.length) return null;
      const F = fontOf(st.back.font), c = mk(W, H), g = ctx2d(c), css = s => `${F.weight} ${s}px ${F.fam}`;
      const R = lines.map(runsOf), pad = s => s * 0.06;
      const widthOf = (rs, s) => rs.reduce((w, r) => w + (r.sym ? symW(s) + 2 * pad(s) : g.measureText(r.t).width), 0);
      g.fillStyle = '#000'; g.fillRect(0, 0, W, H);
      g.fillStyle = g.strokeStyle = '#fff'; g.textAlign = 'left'; g.textBaseline = 'middle';
      let s = H * (lines.length === 1 ? F.k1 : F.k2); g.font = css(s);
      const w = Math.max(...R.map(rs => widthOf(rs, s))), maxW = W * 0.86;
      if (w > maxW) { s *= maxW / w; g.font = css(s); }
      const gap = s * (st.back.font === 'script' ? 1.05 : 1.25), y0 = H / 2 - (lines.length - 1) * gap / 2;
      R.forEach((rs, i) => {
        const y = y0 + i * gap; let x = W / 2 - widthOf(rs, s) / 2;
        for (const r of rs) {
          if (r.sym) { drawSym(g, r.sym, x + pad(s), y - s * 0.04, s); x += symW(s) + 2 * pad(s); }
          else { g.fillText(r.t, x, y); x += g.measureText(r.t).width; }
        }
      });
      const d = g.getImageData(0, 0, W, H).data, m = new Float32Array(W * H);
      for (let i = 0; i < m.length; i++) m[i] = d[4 * i] / 255;
      return m;
    }
    // Gravierbar ist alles von der Tastatur (inkl. Umlaute/Akzente wie ş, ğ, ć) plus die Symbole aus der Auswahl.
    // Herz-Emojis werden zu ♥, alles andere (Emojis, Flaggen, exotische Zeichen) wird nicht angenommen.
    const HEART_EMOJI = /[❣❤\u{1F493}-\u{1F49F}\u{1F5A4}\u{1F90D}\u{1F90E}\u{1F9E1}\u{1FA75}-\u{1FA77}]/gu;
    const KEYBOARD = /^[ -~ -ſȘ-ț–—‘-„•…€™]$/u;
    function cleanText(v, max) { // → bereinigter Text + Grund (blocked = Zeichen entfernt, cut = zu lang)
      // Darstellungs-Selektoren (z. B. hinter ❤️) sind unsichtbar → still entfernen, nicht als Fehler werten
      const all = Array.from(v.replace(HEART_EMOJI, '♥').replace(/[︎️]/g, ''));
      const ok = all.filter(ch => KEYBOARD.test(ch) || SYM.has(ch));
      return { text: ok.slice(0, max).join(''), blocked: ok.length < all.length, cut: ok.length > max };
    }

    /* Zeichnen */
    const dirty = { front: false, back: false };
    let raf = 0;
    function invalidate(...sides) { sides.forEach(s => { dirty[s] = true; }); if (!raf) raf = requestAnimationFrame(frame); }
    function frame() {
      raf = 0;
      if (dirty.front && comp.front) paint('front', st.img ? engraveFront(PREV_W, PREV_H).mask : null, PREV_W, PREV_H);
      if (dirty.back && comp.back) paint('back', textMask(PREV_W, PREV_H), PREV_W, PREV_H);
      dirty.front = dirty.back = false;
      drawCrop(); drawPreview();
    }
    function fitCanvas(c) {
      const w = Math.round(c.clientWidth * dpr()), h = Math.round(c.clientHeight * dpr());
      if (w && h && (c.width !== w || c.height !== h)) { c.width = w; c.height = h; }
    }
    // Vorderseite oben im Block, Rückseite direkt über dem Eingabefeld der Botschaft
    function drawPreview() {
      for (const [side, c] of [['front', el.pvCanvas], ['back', el.pvBack]]) {
        if (!c || !comp[side] || !c.offsetParent) continue;           // ausgeblendet → nichts zu zeichnen
        fitCanvas(c);
        const g = c.getContext('2d'), r = { ...PHOTO.close };
        if (side === 'back') r.x = PHOTO.size - r.x - r.w;
        g.imageSmoothingQuality = 'high';
        g.drawImage(comp[side], r.x, r.y, r.w, r.h, 0, 0, c.width, c.height);
      }
    }
    function frameRect(W, H) {
      let fw = W * 0.92, fh = fw / ASPECT;
      if (fh > H * 0.55) { fh = H * 0.55; fw = fh * ASPECT; }
      return { x: (W - fw) / 2, y: (H - fh) / 2, w: fw, h: fh };
    }
    function drawCrop() {
      const c = el.crop; if (!st.img || el.work.hidden) return;
      fitCanvas(c);
      const W = c.width, H = c.height, g = c.getContext('2d'), f = frameRect(W, H), k = f.w / st.crop.fw;
      g.setTransform(1, 0, 0, 1, 0, 0);
      g.fillStyle = '#1c1917'; g.fillRect(0, 0, W, H);
      g.save(); g.imageSmoothingQuality = 'high';
      g.translate(W / 2, H / 2); g.scale(k, k); g.rotate(-st.crop.a); g.translate(-st.crop.cx, -st.crop.cy);
      drawSource(g, k);
      g.restore();
      g.fillStyle = 'rgba(20,18,17,.6)';
      g.beginPath(); g.rect(0, 0, W, H); g.rect(f.x, f.y, f.w, f.h); g.fill('evenodd');
      g.strokeStyle = '#fff'; g.lineWidth = 2 * dpr(); g.strokeRect(f.x, f.y, f.w, f.h);
    }

    /* Ausschnitt */
    function limits() { const m = Math.max(st.img.width, st.img.height); return { min: Math.max(80, m * 0.04), max: m * 1.4 }; }
    function clampCrop() { // Kunde wählt den Ausschnitt frei; nur unsinnige Werte abfangen
      const c = st.crop, L = limits();
      c.fw = clamp(c.fw, L.min, L.max);
      c.cx = clamp(c.cx, 0, st.img.width); c.cy = clamp(c.cy, 0, st.img.height);
      c.a = clamp(c.a, -Math.PI / 3, Math.PI / 3);
    }
    function cropChanged() {
      clampCrop(); st.fver++; schedulePrep();
      el.warn.hidden = st.crop.fw >= 300;
      el.reset.hidden = !st.base || !st.touched;
      invalidate('front');
    }
    function defaultCrop() {
      const W = st.img.width, H = st.img.height;
      st.crop = { cx: W / 2, cy: H * (W > H ? 0.42 : 0.38), fw: Math.min(W, H) * 0.62, a: 0 };
    }
    function applyEyes(e) {
      const dx = e.r.x - e.l.x, dy = e.r.y - e.l.y, d = Math.hypot(dx, dy), a = Math.atan2(dy, dx);
      const fw = d / (EYE_R - EYE_L), off = (EYE_Y - 0.5) * fw / ASPECT + KP_BELOW * d;
      const mx = (e.l.x + e.r.x) / 2 - (EYE_L + EYE_R - 1) / 2 * fw * Math.cos(a);
      const my = (e.l.y + e.r.y) / 2 - (EYE_L + EYE_R - 1) / 2 * fw * Math.sin(a);
      st.crop = { cx: mx + Math.sin(a) * off, cy: my - Math.cos(a) * off, fw, a };
      st.base = { ...st.crop };
    }
    function panBy(dx, dy) { // CSS-Pixel
      const f = frameRect(el.crop.clientWidth, el.crop.clientHeight), k = f.w / st.crop.fw, a = st.crop.a;
      st.crop.cx -= (dx * Math.cos(a) - dy * Math.sin(a)) / k;
      st.crop.cy -= (dx * Math.sin(a) + dy * Math.cos(a)) / k;
    }
    function zoomAt(f, px, py) {
      const W = el.crop.clientWidth, H = el.crop.clientHeight, L = limits();
      const nfw = clamp(st.crop.fw / f, L.min, L.max), real = st.crop.fw / nfw;
      panBy(-(px - W / 2) * (1 - 1 / real), -(py - H / 2) * (1 - 1 / real));
      st.crop.fw = nfw;
    }
    function rotateAt(da, px, py) { // Drehen um den Punkt zwischen den Fingern (CSS-Pixel im Canvas)
      const W = el.crop.clientWidth, H = el.crop.clientHeight, f = frameRect(W, H), k = f.w / st.crop.fw;
      const ox = px - W / 2, oy = py - H / 2, a = st.crop.a, na = a - da;
      const p = { x: st.crop.cx + (ox * Math.cos(a) - oy * Math.sin(a)) / k, y: st.crop.cy + (ox * Math.sin(a) + oy * Math.cos(a)) / k };
      st.crop.cx = p.x - (ox * Math.cos(na) - oy * Math.sin(na)) / k;
      st.crop.cy = p.y - (ox * Math.sin(na) + oy * Math.cos(na)) / k;
      st.crop.a = na;
    }
    // 1 Finger verschiebt, 2 Finger zoomen; Drehen erst ab ~8° Verdrehung, damit Zoomen nicht versehentlich dreht
    const ptrs = new Map(); let gest = null, twist = 0, rotating = false;
    function gesture() {
      const p = [...ptrs.values()]; if (!p.length) return null;
      return {
        x: p.reduce((s, v) => s + v.x, 0) / p.length, y: p.reduce((s, v) => s + v.y, 0) / p.length,
        d: p.length > 1 ? Math.hypot(p[0].x - p[1].x, p[0].y - p[1].y) : 0,
        ang: p.length > 1 ? Math.atan2(p[1].y - p[0].y, p[1].x - p[0].x) : 0, n: p.length,
      };
    }
    el.crop.addEventListener('pointerdown', e => {
      if (st.busy) return;
      try { el.crop.setPointerCapture(e.pointerId); } catch (_) {}
      ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
      gest = gesture(); twist = 0; rotating = false;
    });
    el.crop.addEventListener('pointermove', e => {
      if (!ptrs.has(e.pointerId)) return;
      ptrs.set(e.pointerId, { x: e.clientX, y: e.clientY });
      const g = gesture();
      if (gest && g.n === gest.n) {
        panBy(g.x - gest.x, g.y - gest.y);
        if (g.n > 1 && gest.d > 0) {
          const r = el.crop.getBoundingClientRect(), px = g.x - r.left, py = g.y - r.top;
          zoomAt(g.d / gest.d, px, py);
          let da = g.ang - gest.ang; da = Math.atan2(Math.sin(da), Math.cos(da));
          twist += da;
          if (!rotating && Math.abs(twist) > 0.14) { rotating = true; da = twist; }
          if (rotating) rotateAt(da, px, py);
        }
        st.touched = true; el.cropHint.hidden = true;
        cropChanged();
      }
      gest = g;
    });
    const endPtr = e => { ptrs.delete(e.pointerId); gest = gesture(); };
    el.crop.addEventListener('pointerup', endPtr);
    el.crop.addEventListener('pointercancel', endPtr);
    el.crop.addEventListener('wheel', e => {
      if (st.busy) return;
      e.preventDefault();
      const r = el.crop.getBoundingClientRect();
      zoomAt(Math.exp(-e.deltaY * 0.0015), e.clientX - r.left, e.clientY - r.top);
      st.touched = true; cropChanged();
    }, { passive: false });
    el.reset.addEventListener('click', () => {
      if (!st.base) return;
      st.crop = { ...st.base }; st.touched = false; cropChanged();
    });

    /* Status & Fehler */
    function setStatus(text, cls) { el.status.textContent = text; el.status.className = 'ag-status' + (cls ? ' is-' + cls : ''); }
    function setBusy(on) { st.busy = on; el.busy.hidden = !on; }

    /* Upload */
    async function loadFile(file) {
      if (!file) return;
      el.err.hidden = true;
      if (file.type && !file.type.startsWith('image/')) { showErr(T.errFormat); return; }
      const url = URL.createObjectURL(file), im = new Image();
      try { await new Promise((res, rej) => { im.onload = res; im.onerror = rej; im.src = url; }); } // onload statt decode(): läuft auch in Hintergrund-Tabs
      catch (_) { URL.revokeObjectURL(url); showErr(T.errFormat); return; }
      const s = Math.min(1, 4000 / Math.max(im.naturalWidth, im.naturalHeight));
      const c = mk(Math.round(im.naturalWidth * s), Math.round(im.naturalHeight * s)), g = c.getContext('2d');
      g.imageSmoothingQuality = 'high'; g.drawImage(im, 0, 0, c.width, c.height);
      URL.revokeObjectURL(url);
      st.img = c; st.pyr = buildPyramid(c); st.token++; st.base = null; st.touched = false;
      const token = st.token;
      defaultCrop();
      el.upload.hidden = true; el.work.hidden = false; el.pv.hidden = false;
      el.cropHint.textContent = T.hintFree; el.cropHint.hidden = false;
      // Foto sofort zeigen und bedienbar machen; die Augen-Erkennung läuft im Hintergrund
      st.detecting = true; setStatus(T.statusSearching || '', 'busy');
      cropChanged();
      loadPhoto().catch(() => {});
      prefetchTickets(); // Freigabe für den Warenkorb schon bereitlegen
      let eyes = null, failed = false;
      try { eyes = findEyes(await timeout(loadDetector(), 20000), st.img); } catch (_) { failed = true; }
      if (token !== st.token) return;
      st.detecting = false;
      if (eyes) { // Startrahmen auf den Augen – außer der Kunde hat inzwischen selbst verschoben
        const own = st.touched ? { ...st.crop } : null;
        applyEyes(eyes);
        if (own) st.crop = own;
        setStatus(T.statusAuto, 'ok');
      } else setStatus(failed ? T.statusNoDetector : T.statusNoEyes, 'warn');
      cropChanged();
    }
    function showErr(msg) { el.err.textContent = msg; el.err.hidden = false; }
    el.file.addEventListener('change', e => { loadFile(e.target.files[0]); e.target.value = ''; });
    el.change.addEventListener('click', () => el.file.click());
    // Erkennung und Produktfoto schon laden, während die Fotoauswahl offen ist
    const warmUp = () => { loadDetector().catch(() => {}); loadPhoto().catch(() => {}); };
    el.upload.addEventListener('pointerdown', warmUp, { once: true });
    el.upload.addEventListener('focusin', warmUp, { once: true });

    /* Rückseite (Upsell) */
    if (el.backCheck) {
      el.backCheck.addEventListener('change', () => {
        st.back.on = el.backCheck.checked; st.bver++; schedulePrep();
        root.classList.toggle('is-back', st.back.on);
        el.backPanel.hidden = !st.back.on;
        if (st.back.on) { loadPhoto().catch(() => {}); loadFont('script'); loadFont('clean'); }
        else el.backErr.hidden = true;
        invalidate('back');
      });
      const MAX = Number(el.l1.maxLength) || 13;
      let lastInput = el.l1;
      const syncLine = (inp, cnt, key) => {
        st.back[key] = inp.value; st.bver++; schedulePrep();
        cnt.textContent = `${Array.from(inp.value).length}/${MAX}`;
        if (backLines().length) { el.backErr.hidden = true; el.l1.classList.remove('is-error'); }
        invalidate('back');
      };
      for (const [inp, cnt, key] of [[el.l1, el.c1, 'l1'], [el.l2, el.c2, 'l2']]) {
        for (const t of ['focus', 'pointerdown', 'keyup']) inp.addEventListener(t, () => { lastInput = inp; });
        inp.addEventListener('input', () => {
          const c = cleanText(inp.value, MAX);
          if (c.text !== inp.value) { // Zeichen entfernt, Herz-Emoji zu ♥ gemacht oder zu lang eingefügt
            const pos = Math.min(inp.selectionStart || c.text.length, c.text.length);
            inp.value = c.text; try { inp.setSelectionRange(pos, pos); } catch (_) {}
          }
          if (c.blocked || c.cut) { el.symHint.textContent = c.blocked ? T.emojiHint : T.lineFull; el.symHint.hidden = false; }
          else el.symHint.hidden = true;
          syncLine(inp, cnt, key);
        });
      }
      // Symbol-Icon rechts im Eingabefeld öffnet die Auswahl gravierbarer Symbole direkt unter der Zeile.
      // Einfügen an der Cursorposition; pointerdown wird abgefangen, damit die Handy-Tastatur offen bleibt.
      function insertSym(inp, ch) {
        const cnt = inp === el.l1 ? el.c1 : el.c2, key = inp === el.l1 ? 'l1' : 'l2';
        if (Array.from(inp.value).length >= MAX) { el.symHint.textContent = T.lineFull; el.symHint.hidden = false; return; }
        const a = inp.selectionStart ?? inp.value.length, z = inp.selectionEnd ?? a;
        inp.value = inp.value.slice(0, a) + ch + inp.value.slice(z);
        try { inp.setSelectionRange(a + 1, a + 1); } catch (_) {}
        el.symHint.hidden = true;
        syncLine(inp, cnt, key);
      }
      let pop = null, popFor = null;
      function closePop() {
        if (pop) pop.remove();
        pop = popFor = null;
        root.querySelectorAll('.ag-symbtn').forEach(b => b.setAttribute('aria-expanded', 'false'));
      }
      function openPop(btn, inp) {
        closePop(); popFor = inp;
        pop = document.createElement('div');
        pop.className = 'ag-sympop'; pop.setAttribute('role', 'group'); pop.setAttribute('aria-label', T.symLabel);
        pop.innerHTML = SYMBOLS.map(s => `<button type="button" data-sym="${s.ch}" aria-label="${s.name}">${symSvg(s)}</button>`).join('');
        pop.addEventListener('pointerdown', e => e.preventDefault());
        pop.addEventListener('click', e => { const b = e.target.closest('[data-sym]'); if (b) insertSym(popFor, b.dataset.sym); });
        btn.closest('.ag-field').after(pop);
        btn.setAttribute('aria-expanded', 'true');
      }
      root.querySelectorAll('.ag-symbtn').forEach(btn => {
        const inp = btn.closest('.ag-inwrap').querySelector('input');
        btn.addEventListener('pointerdown', e => e.preventDefault());
        btn.addEventListener('click', e => { e.preventDefault(); lastInput = inp; popFor === inp ? closePop() : openPop(btn, inp); });
      });
      document.addEventListener('click', e => {
        if (pop && !e.target.closest('.ag-sympop, .ag-symbtn') && e.target !== popFor) closePop();
      });
      el.fonts.querySelectorAll('button').forEach(b => { b.style.fontFamily = fontOf(b.dataset.font).fam; });
      el.fonts.addEventListener('click', e => {
        const b = e.target.closest('button'); if (!b) return;
        st.back.font = b.dataset.font; st.bver++; schedulePrep();
        el.fonts.querySelectorAll('button').forEach(x => x.setAttribute('aria-pressed', String(x === b)));
        loadFont(st.back.font);
        invalidate('back');
      });
    }

    /* Warenkorb: Dateien je Seite einmal rechnen und hochladen (Vorderseite = Ausschnitt, Rückseite = Text) */
    const memo = () => {
      let c = null;
      return {
        get(ver, make) { if (!c || c.ver !== ver) c = { ver, p: make() }; return c.p; },
        drop(p) { if (c && c.p === p) c = null; },
      };
    };
    const ENG_W = ENG.wMM * ENG.pxPerMM, ENG_H = ENG.hMM * ENG.pxPerMM;
    const frontM = memo(), backM = memo();
    function frontFiles() { // synchron vom aktuellen Stand rechnen, Blobs danach
      return frontM.get(st.fver, () => {
        const f = engraveFront(ENG_W, ENG_H);
        const sw = Math.round(clamp(st.crop.fw, ENG_W, 1600)), sh = Math.round(sw / ASPECT);
        const srcC = cropCanvas(sw, sh);
        const meta = `${ENG.wMM}×${ENG.hMM} mm · ${Math.round(ENG.pxPerMM * 25.4)} dpi · ` +
          (st.base ? (st.touched ? T.metaAdjusted : T.metaAuto) : T.metaManual);
        return Promise.all([
          toBlob(toCanvas(f.mask, ENG_W, ENG_H, true), 'image/png'),
          toBlob(toCanvas(f.gray, ENG_W, ENG_H, false), 'image/png'),
          toBlob(srcC, 'image/jpeg', 0.9),
        ]).then(([bw, gray, src]) => ({ bw, gray, src, meta }));
      });
    }
    function backFile() {
      return backM.get(st.bver, () => {
        const t = textMask(ENG_W, ENG_H);
        return t ? toBlob(toCanvas(t, ENG_W, ENG_H, true), 'image/png') : Promise.resolve(null);
      });
    }
    async function withFiles(body) {
      let fd = body;
      if (!(body instanceof FormData)) { // JSON/URL-Body in FormData umbauen, damit Dateien mitkönnen
        fd = new FormData();
        let obj = null;
        if (typeof body === 'string') { try { obj = JSON.parse(body); } catch (_) { new URLSearchParams(body).forEach((v, k) => fd.append(k, v)); } }
        else if (body instanceof URLSearchParams) body.forEach((v, k) => fd.append(k, v));
        if (obj) {
          if (obj.items) return null;
          Object.keys(obj).forEach(k => {
            const v = obj[k];
            if (k === 'properties' && v) Object.keys(v).forEach(pk => fd.append(`properties[${pk}]`, v[pk]));
            else if (Array.isArray(v)) fd.append(k, v.join(','));
            else if (v != null) fd.append(k, v);
          });
        }
      }
      const f = await frontFiles(), c = await cartBatchOrNull();
      if (c) { // Normalfall: Links stehen sofort fest, die Dateien laden im Hintergrund nach Cloudinary
        fd.set(`properties[${P.file}]`, c.urls.gravur);
        fd.set(`properties[${P.gray}]`, c.urls.graustufen);
        fd.set(`properties[${P.src}]`, c.urls.ausschnitt);
        fd.set(`properties[${P.meta}]`, f.meta);
      } else {  // Rückfall: keine Freigabe vom Portal → Dateien direkt an Shopify, damit nichts verloren geht
        fd.set(`properties[${P.file}]`, f.bw, 'augen-gravur.png');
        fd.set(`properties[${P.gray}]`, f.gray, 'augen-gravur-graustufen.png');
        fd.set(`properties[${P.src}]`, f.src, 'augen-foto-ausschnitt.jpg');
        fd.set(`properties[${P.meta}]`, f.meta + ' · ' + T.metaFallback);
      }
      return fd;
    }
    let lastUpsell = 0;
    async function addUpsell(qty) {
      if (!st.back.on || !cfg.upsellVariantId) return;
      const now = Date.now(); if (now - lastUpsell < 1500) return; lastUpsell = now;
      const b = await backFile(), c = b ? await cartBatchOrNull() : null, fd = new FormData();
      fd.append('id', cfg.upsellVariantId); fd.append('quantity', qty);
      fd.append(`properties[${P.back}]`, backLines().join(' / '));
      fd.append(`properties[${P.backFont}]`, T.fonts[st.back.font]);
      if (c && c.urls.rueckseite) fd.append(`properties[${P.backFile}]`, c.urls.rueckseite);
      else if (b) fd.append(`properties[${P.backFile}]`, b, 'augen-gravur-rueckseite.png');
      fd.append(`properties[${P.for}]`, cfg.productTitle);
      return origFetch.call(window, cfg.cartAddUrl + '.js', { method: 'POST', body: fd, headers: { Accept: 'application/json' } });
    }

    /* Cloudinary ohne Wartezeit beim „In den Warenkorb“:
       Die Freigabe (feste Dateinamen) liegt schon bereit, sobald ein Foto gewählt ist. Beim Klick stehen die Links damit
       sofort fest, der Artikel geht direkt in den Warenkorb und die Dateien laden im Hintergrund hoch. „Zur Kasse“ wartet,
       bis sie oben sind (siehe holdNavigation). Hochgeladen wird erst beim Warenkorb, nicht beim Ausprobieren. */
    const fetchT = (url, opts, ms) => {
      const ac = new AbortController(), t = setTimeout(() => ac.abort(), ms);
      return origFetch.call(window, url, Object.assign({}, opts, { signal: ac.signal })).finally(() => clearTimeout(t));
    };
    const KINDS = ['gravur', 'graustufen', 'ausschnitt', 'rueckseite'];
    let spare = null; // { at, p }
    function prefetchTickets() {
      if (!cfg.uploadUrl || (spare && Date.now() - spare.at < 40 * 60000)) return; // Signatur gilt bei Cloudinary 1 h
      const p = fetchT(cfg.uploadUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ files: KINDS }),
      }, 8000).then(r => { if (!r.ok) throw new Error('Freigabe ' + r.status); return r.json(); });
      spare = { at: Date.now(), p };
      p.catch(() => { if (spare && spare.p === p) spare = null; });
    }
    function takeTickets() { prefetchTickets(); const p = spare.p; spare = null; return p; }
    async function uploadOne(t, blob, kind, ext) { // gleiche Signatur, gleicher Dateiname → Wiederholen ist gefahrlos
      for (let i = 0; i < 3; i++) {
        try {
          const fd = new FormData();
          fd.append('file', blob, `${kind}.${ext}`);
          fd.append('api_key', t.apiKey); fd.append('timestamp', t.timestamp); fd.append('signature', t.signature);
          fd.append('public_id', t.publicId); fd.append('tags', t.tags); fd.append('allowed_formats', t.allowedFormats);
          const j = await (await fetchT(t.url, { method: 'POST', body: fd }, 45000)).json();
          if (j.secure_url) return j.secure_url;
        } catch (_) {}
        await new Promise(r => setTimeout(r, 1500 * (i + 1)));
      }
      throw new Error('Upload ' + kind);
    }
    const cartM = memo();
    function cartBatch() { // je Stand (Vorder- + Rückseite) eine Freigabe, alle Dateien parallel
      const p = cartM.get(st.fver + ':' + st.bver, () => Promise.all([frontFiles(), backFile(), takeTickets()]).then(([f, b, set]) => {
        const want = { gravur: [f.bw, 'png'], graustufen: [f.gray, 'png'], ausschnitt: [f.src, 'jpg'] };
        if (b) want.rueckseite = [b, 'png'];
        const urls = {}, jobs = [];
        for (const k of Object.keys(want)) {
          const t = set.tickets[k], cloud = t.url.split('/v1_1/')[1].split('/')[0];
          urls[k] = `https://res.cloudinary.com/${cloud}/image/upload/${t.publicId}.${want[k][1]}`;
          jobs.push(uploadOne(t, want[k][0], k, want[k][1]));
        }
        const done = Promise.all(jobs);
        trackUpload(done);
        done.catch(() => showErr(T.errUpload));
        return { urls, done };
      }));
      p.catch(() => cartM.drop(p));
      return p;
    }
    async function cartBatchOrNull() { // wartet nur auf die Freigabe (meist schon da), nie auf den Upload
      if (!cfg.uploadUrl) return null;
      try { return await timeout(cartBatch(), 6000); } catch (_) { try { return await timeout(cartBatch(), 6000); } catch (__) { return null; } }
    }
    // Lokal vorrechnen, solange der Kunde kurz nichts ändert – kein Upload; nur Rechenzeit sparen und Freigabe bereitlegen
    let prepT = 0;
    function schedulePrep() {
      clearTimeout(prepT);
      prepT = setTimeout(() => {
        if (st.detecting || ptrs.size) { schedulePrep(); return; }
        if (st.img) { frontFiles(); prefetchTickets(); }
        if (st.back.on && backLines().length) backFile();
      }, 800);
    }
    function problem() {
      if (!st.img) return { msg: T.errPhoto, where: 'photo' };
      if (st.back.on && cfg.upsellVariantId && !backLines().length) return { msg: T.errBack, where: 'back' };
      return null;
    }
    function showProblem(p) {
      const target = p.where === 'back' ? el.l1 : root;
      if (p.where === 'back') { el.backErr.hidden = false; el.l1.classList.add('is-error'); }
      else showErr(p.msg);
      target.scrollIntoView({ behavior: 'smooth', block: 'center' });
      root.classList.remove('is-shake'); void root.offsetWidth; root.classList.add('is-shake');
    }

    instances.push({ ids: new Set(cfg.variantIds.map(String)), problem, showProblem, withFiles, addUpsell });
    if ('ResizeObserver' in window) new ResizeObserver(() => { drawPreview(); drawCrop(); }).observe(root);
  }

  const boot = () => document.querySelectorAll('[data-augen-gravur]').forEach(init);
  window.AugenGravur = { init, boot };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
